module.exports = __webpack_public_path__ + "img/values(1).021ca980.png";